import axios from 'axios'
import { REACT_APP_COTIZADOR_API } from 'cfgCommon/config'

export async function getQuotations({ search, cancelToken }){
    const parsedSearch = JSON.parse('{"' + (search).replace('?', '').replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')

    const skip = parseInt(parsedSearch.page) * parseInt(parsedSearch.per_page) - parseInt(parsedSearch.per_page)

    const endpoint = new URL(`${REACT_APP_COTIZADOR_API}/cotizador/v1/quotes/v2`, window.location.href)
    endpoint.searchParams.append('limit', parsedSearch.per_page)
    endpoint.searchParams.append('skip', skip)
    endpoint.searchParams.append('dinamicPagination', parsedSearch.dinamicPagination)
    if (parsedSearch.sort) endpoint.searchParams.append('order', parsedSearch.sort)

    if (parsedSearch.search) endpoint.searchParams.append('search', parsedSearch.search)

    let { data } = await axios.get(endpoint.href, {cancelToken})

    const flattenedQuotations = data?.data?.map(
        quotation => {
            const flatten = {
                ...quotation,
                ...quotation.vehicle,
                ...quotation.quote,
            }

            const discounts = {
                kmDiscountAmount:flatten.discounts[0]?.amount,
                kmDiscountPercentage: flatten.discounts[0]?.percentage,
                interiorDiscountAmount: flatten.discounts[1]?.amount,
                interiorDiscountPercentage: flatten.discounts[1]?.percentage,
            }

            const costs = {
                generalCosts: flatten.costs[0]?.amount,
                accessoriesAmount: flatten.accessoriesAmount,
            }
            const estimatedPrice = flatten.prices[1]?.amount

            delete flatten.vehicle;
            delete flatten.quote;
            delete flatten.discounts;

            return {...flatten, ...discounts, ...costs, estimatedPrice}
        })

    data.data = flattenedQuotations

    return data
}
